import { Spin } from "antd";
import { HeaderActionsContainer } from "../../containers/HeaderActionsContainer";
import { HeaderContainer } from "../../containers/HeaderContainer";
import { SignInGovBrButton } from "../SignInGovBrButton/SignInGovBrButton";
import { Launch } from "@mui/icons-material";
import {
  FullHeightContainer,
  WhiteCard,
  Separator,
  HelpTitle,
  HelpLink,
  FullHeightRow,
  PageText,
  DisclaimerText,
  SignInGovBrButtonContainer,
  WhiteCardContent,
  HelpSection,
} from "./style";

export interface RedirectSsoLoginPageProps {
  isWaiting: boolean;
  redirect: () => void;
  isSmallScreen: boolean;
}

export const RedirectSsoLoginPage = ({
  isWaiting,
  redirect,
  isSmallScreen,
}: RedirectSsoLoginPageProps) => (
  <div className="xvia-main-app">
    <HeaderContainer rightElement={<HeaderActionsContainer />} />

    <div
      className="xvia-content-area"
      style={{
        background: "#00147b",
        height: "100%",
      }}
    >
      <FullHeightContainer sm>
        {isWaiting ? (
          <FullHeightRow justifyContent="center" alignItems="center">
            <Spin />
          </FullHeightRow>
        ) : (
          <FullHeightRow
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap={8}
          >
            <img
              src="/assets/img/logo/logo-pe-origin-contrast.png"
              alt="Logo de Pernambuco"
              width={isSmallScreen ? 200 : 250}
            />
            <PageText>
              Tenha acesso a mais de 300 serviços públicos digitais com toda
              segurança e praticidade através da sua conta gov.br.
            </PageText>

            <WhiteCard>
              <WhiteCardContent
                flexDirection="column"
                alignItems="center"
                gap={4}
              >
                <SignInGovBrButtonContainer>
                  <SignInGovBrButton onClick={redirect} />
                </SignInGovBrButtonContainer>
                <DisclaimerText isSmallScreen={isSmallScreen}>
                  Ao clicar você será redirecionado para a autenticação gov.br.
                  Ao acessar o gov.br, o portal de Pernambuco carregará
                  automaticamente.
                </DisclaimerText>
                <Separator />
                <HelpSection flexDirection="column">
                  <HelpTitle>Precisa de ajuda?</HelpTitle>
                  <HelpLink
                    href="https://www.gov.br/pt-br/servicos/criar-sua-conta-gov.br"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Não possuo conta gov.br
                    <Launch />
                  </HelpLink>
                  <HelpLink
                    href="https://www.gov.br/receitafederal/pt-br/assuntos/meu-cpf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Não possuo CPF
                    <Launch />
                  </HelpLink>
                </HelpSection>
              </WhiteCardContent>
            </WhiteCard>
          </FullHeightRow>
        )}
      </FullHeightContainer>
    </div>
  </div>
);
